export const copyTextToClipboard = async (text: string) => {
  return new Promise((resolve) => {
    if (!navigator.clipboard) {
      // Clipboard API not available (possibly due to an insecure context or lack of browser support)
      // Fallback method: using document.execCommand() for older browsers
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        resolve(true)
      } catch (err) {
        console.error('Failed to copy text: ', err)
        resolve(false)
      } finally {
        document.body.removeChild(textarea)
      }
    } else {
      // Using Clipboard API
      navigator.clipboard.writeText(text).then(
        function () {
          resolve(true)
          // console.log('Text successfully copied to clipboard');
        },
        function (err) {
          resolve(false)
          console.error('Failed to copy text: ', err)
        },
      )
    }
  })
}
